module.exports = __webpack_public_path__ + "img/logo-google.7b6a2d59.png";